export const idToGid = (resource, id) =>
  `gid://shopify/${resource}/${id}`;
